import React from 'react';
import { LFC } from '../../../Legacy';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { useActiveMeeting } from './MeetingHooks';

export const ShowIfMeetingHost: LFC = ({ children }) => {
    const meeting = useActiveMeeting();
    const me = useResolve(ProfileModel);
    if (meeting && meeting.facilitators.includes(me.id)) {
        return <>{children}</>;
    }
    else {
        return null;
    }
};
